module.exports = __webpack_public_path__ + "img/closecard.18145345.svg";